import styled from 'styled-components';
import { Skeleton } from '@elfsight/widget-ui';

export function MediaSkeleton() {
  return (
    <SkeletonContainer>
      <Skeleton width="100%" height="100%" borderRadius={0} animated={false} />
    </SkeletonContainer>
  );
}

const SkeletonContainer = styled.div`
  position: absolute;
  inset: 0;
  z-index: 10;
  background: #fff;
`;
